import { QUERIES } from '@repo/ui/queries';
import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

import { FlexRow } from 'styles/layouts';

const getMinMaxMedia = (minWidth?: string, maxWidth?: string): string => {
  const mediaWidth = [];
  if (minWidth) {
    mediaWidth.push(`(min-width: ${minWidth})`);
  }
  if (maxWidth) {
    mediaWidth.push(`(max-width: ${maxWidth})`);
  }
  return `@media ${mediaWidth.join(' and ')} { display: flex; gap: 8px; }`;
};

export const Wrapper = styled.div<{ hasBanner?: boolean }>`
  position: fixed;
  z-index: ${themeStyle.zIndexS3};
  top: ${({ hasBanner }) => (hasBanner ? 'var(--banner-height)' : '0px')};
  box-sizing: border-box;
  width: 100%;
`;

export const HeaderWrapper = styled(FlexRow)`
  z-index: ${themeStyle.zIndexS3};
  position: relative;
  width: 100%;
  height: var(--header-height);
  align-items: center;
  transition: background 0.3s;

  &::before {
    content: '';
    position: absolute;
    height: 100%;
    width: 100%;
    background: ${themeStyle.varBackgroundAlt};
    box-shadow: rgba(0, 0, 0, 0.12) 0 1px 6px;
  }

  html[data-theme='dark'] &&,
  .dark && {
    &::before {
      backdrop-filter: blur(4px);
      box-shadow: 0 1px 6px rgba(0, 0, 0, 0.32);
    }
  }
`;

export const HeaderGrid = styled(FlexRow)`
  width: 100%;
  position: relative;
  align-items: center;
  justify-content: space-between;

  padding: 0 12px;
  ${QUERIES.tabletAndUp} {
    padding: 0 48px;
  }

  gap: 12px;
`;

export const IconsWrapper = styled.div`
  height: 45px;
  display: inline-flex;
  align-items: center;
  padding: 0 12px;
  gap: 12px;
`;

export const WidthResolutions = styled.div<{ min?: string; max?: string }>`
  display: none;

  ${({ min, max }) => getMinMaxMedia(min, max)}
`;
